var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img_carousel"},_vm._l((_vm.images),function(ref){
var id = ref.id;
var url = ref.url;
var caption = ref.caption;
return _c('v-carousel-item',{key:id},[_c('v-card',{attrs:{"max-height":"1300","max-width":"500"}},[_c('v-img',{staticClass:"c_image",attrs:{"src":url,"alt":"gallery_image"}}),(caption)?_c('v-card-subtitle',[_vm._v(" "+_vm._s(caption))]):_vm._e()],1)],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }